import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs/operators';
import { AuthService } from '../auth/auth.service';
import { VersionService } from '../services/version.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const versions = inject(VersionService);
  const token = auth.getAccessToken();

  const outReq = token && !req.url.includes('/api/login/refresh-token')
    ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
    : req;

  return next(outReq).pipe(
    tap(event => {
      if (event instanceof HttpResponse) {
        const v = event.headers.get('x-version');
        if (v) versions.setBackendVersion(v);
      }
    })
  );
};
